import AsyncSelect, { AsyncProps } from 'react-select/async';
import { FC, memo } from 'react';
import { GroupBase } from 'react-select';

export const Component: FC<AsyncProps<unknown, false, GroupBase<any>> & { disabled: boolean }> = memo((props) => {
    const { disabled = false, required = false, value = '', cacheOptions = true, defaultOptions = true, ...restProps } = props;

    return (
        <AsyncSelect
            className="w-100"
            isDisabled={disabled}
            required={required}
            value={value}
            cacheOptions={cacheOptions}
            defaultOptions={defaultOptions}
            {...restProps}
        />
    );
});
Component.displayName = 'Autocomplete';
